var _style, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeal = function SvgMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    width: 60,
    height: 60
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".meal-svg-icon{fill:none;}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "meal-svg-icon",
    width: 60,
    height: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 59c-0.9 0-1.6-0.8-1.6-1.7V2.7C17.4 1.8 18.1 1 19 1c0.9 0 1.6 0.8 1.6 1.7v54.7C20.6 58.2 19.9 59 19 59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 29.2c-4.8 0-8.8-4.2-8.8-9.3V2.7C10.3 1.8 11 1 11.9 1c0.9 0 1.6 0.8 1.6 1.7v17.2c0 3.3 2.5 5.9 5.5 5.9s5.5-2.6 5.5-5.9V2.7C24.4 1.8 25.1 1 26 1c0.9 0 1.8 0.8 1.8 1.7v17.2C27.8 25 23.9 29.2 19.1 29.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 59c-0.9 0-1.6-0.8-1.6-1.7V4.5c0-1.6 1.1-3 2.8-3.4 1.5-0.3 3.2 0.1 4.1 1.4 8.4 11 8.9 22.7 9.3 33 0.1 1.5-0.6 3-1.8 4 -1.1 0.9-2.6 1.5-4.2 1.4h-6.9v16.5C39.7 58.2 38.9 59 38.1 59zM39.7 37.4h7.1c0.8 0 1.6-0.2 2.1-0.7 0.5-0.3 0.7-0.8 0.6-1.3 -0.5-10.3-0.9-20.8-8.7-31 -0.1-0.1-0.5-0.2-0.8-0.1 -0.2 0-0.3 0.1-0.3 0.2L39.7 37.4z"
  })));
};
export default SvgMeal;